// src/components/blog/BlogImage.jsx
import React from "react";

export default function BlogImage({ src, alt = "", caption }) {
	return (
		<div className="my-12 text-center">
			<img
				src={src}
				alt={alt}
				className="mx-auto rounded-lg shadow-lg max-w-full"
			/>
			{caption && (
				<p className="mt-3 text-sm text-gray-500 italic">{caption}</p>
			)}
		</div>
	);
}
